import { PayloadAction } from '@reduxjs/toolkit';
import { cancelarSocio } from '../../api/miembros/miembroSocio';
import { GenericState } from '../../types/apiModule';
import { User } from '../../types/users/users';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listMiembrosRefresh } from './listMiembrosModule';
import { t } from '../../i18n';

export interface cancelAssociateSubscriptionState
  extends GenericState<unknown> {
  active: boolean;
  user: User;
}
const initialState: cancelAssociateSubscriptionState = {
  errors: null,
  data: [],
  loading: false,
  active: false,
  user: {} as User,
};

const cancelAssociateSubscriptionModule = createApiModule({
  name: 'cancelAssociateSubscription',
  initialState,
  apiMethod: cancelarSocio,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_MIEMBRO_NO_SOCIO'),
    }),
    listMiembrosRefresh(),
  ],
  onError: () => ({
    message: t(
      'StoreMiembrosCancelAssociateSubscriptionErrorAlCancelarLaSubscripcionDeSocioDelMiembro',
    ),
  }),
  onValidationError: () => ({
    message: t(
      'StoreMiembrosCancelAssociateSubscriptionErrorAlCancelarLaSubscripcionDeSocioDelMiembro',
    ),
  }),
  reducers: {
    show(state, action: PayloadAction<User>) {
      state.active = true;
      state.user = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: cancelAssociateSubscription,
  success: cancelAssociateSubscriptionOk,
  error: cancelAssociateSubscriptionKo,
  hide,
  show,
} = cancelAssociateSubscriptionModule.slice.actions;

export default cancelAssociateSubscriptionModule;
